module.exports = __webpack_public_path__ + "img/logo.c8de400e.svg";